// @flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
import Modal from 'app/common/react/ui/Modal';
import { Box, Button, Text } from 'gestalt';

type Props = {|
  connectType: 'facebook' | 'google',
  onConfirm: () => void,
|};

const ConnectedAccountSuccessModal = ({ connectType, onConfirm }: Props) => (
  <Modal
    accessibilityCloseLabel={i18n._(
      'Close',
      'Button text for closing account connect confirmation',
    )}
    accessibilityModalLabel={i18n._(
      'Successfully connected account',
      'Accessible label for success message after account connect',
    )}
    onDismiss={onConfirm}
    heading={i18n._('Success!', 'Title for success message after account connect')}
    footer={
      <Box marginLeft={-1} marginRight={-1}>
        <Box padding={1}>
          <Button
            size="lg"
            color="red"
            text={i18n._('Got it', 'Button text for accepting account connect confirmation')}
            onClick={onConfirm}
          />
        </Box>
      </Box>
    }
    role="alertdialog"
  >
    <Box padding={4}>
      <Text>
        {connectType === 'google'
          ? i18n._(
              'You can now log into Pinterest with your Google account.',
              'Inform users they should log in with Google after compromised account flow',
            )
          : i18n._(
              'You can now log into Pinterest with your Facebook account.',
              'Inform users they should log in with Facebook after compromised account flow',
            )}
      </Text>
    </Box>
    <Box paddingBottom={4} paddingX={4}>
      <Text>
        {i18n._(
          'That means your old password will no longer work.',
          'Inform users they cannot login with a password after using social connect in compromised account flow',
        )}
      </Text>
    </Box>
  </Modal>
);

export default ConnectedAccountSuccessModal;
